import { render, staticRenderFns } from "./Nearby.vue?vue&type=template&id=63d4b551"
import script from "./Nearby.vue?vue&type=script&lang=ts"
export * from "./Nearby.vue?vue&type=script&lang=ts"
import style0 from "./Nearby.vue?vue&type=style&index=0&id=63d4b551&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports